import { CHAINS } from "../../utils/constants";
import {
  HWCConnector,
  HashpackConnector,
  KabilaConnector,
  MetamaskConnector
} from "@buidlerlabs/hashgraph-react-wallets/connectors";
import { HashpackHNSResolver } from "@buidlerlabs/hashgraph-react-wallets/hns-resolvers";
import { HWBridgeProvider } from "@buidlerlabs/hashgraph-react-wallets";
import HeadstarterLogo from "../../assets/media/headstarter_logo.png";
import { FullPageLoader } from "../../components/reusable/FullPageLoader";

const metadata = {
  name: "HeadStarter | Administrative Panel",
  description: "HeadStarter | The Launchpad of the Hedera Hashgraph ecosystem",
  icons: [HeadstarterLogo],
  url: window.location.href
};

const ReactWalletsProvider = ({ children }) => {
  return (
    <HWBridgeProvider
      LoadingFallback={() => <FullPageLoader label="Initializing..." />}
      metadata={metadata}
      projectId={process.env.REACT_APP_WC_PROJECT_ID}
      connectors={[
        HWCConnector,
        HashpackConnector,
        KabilaConnector,
        [MetamaskConnector, { hnsResolver: HashpackHNSResolver }]
      ]}
      chains={CHAINS}
      multiSession={false}
    >
      {children}
    </HWBridgeProvider>
  );
};

export default ReactWalletsProvider;
